'use strict'

module.exports = class DesktopSearch extends Backbone.Model
  url: '/browse/search/partial'
